"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _FacetFilterStyle = _interopRequireDefault(require("./FacetFilterStyle"));
var _FacetSectionView = _interopRequireDefault(require("./components/section/FacetSectionView"));
var _ReduxFacetView = _interopRequireDefault(require("./components/facet/ReduxFacetView"));
var _FilterItems = _interopRequireDefault(require("./components/inputs/FilterItems"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable arrow-body-style */
/* eslint-disable padded-blocks */

var BentoFacetFilter = function BentoFacetFilter(_ref) {
  var sideBarSections = _ref.sideBarSections,
    CustomFacetSection = _ref.CustomFacetSection,
    CustomFacetView = _ref.CustomFacetView;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, sideBarSections.map(function (section, index) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Divider, {
      variant: "middle",
      className: "divider".concat(index)
    }), /*#__PURE__*/_react.default.createElement(_FacetSectionView.default, {
      section: section,
      CustomSection: CustomFacetSection
    }, section.items.map(function (facet) {
      return /*#__PURE__*/_react.default.createElement(_ReduxFacetView.default, {
        facet: facet,
        CustomView: CustomFacetView
      }, /*#__PURE__*/_react.default.createElement(_core.List, {
        className: "List_".concat(facet.label)
      }, /*#__PURE__*/_react.default.createElement(_FilterItems.default, {
        facet: facet
      })));
    })));
  }));
};
var _default = (0, _core.withStyles)(_FacetFilterStyle.default)(BentoFacetFilter);
exports.default = _default;